module.exports = __webpack_public_path__ + "static/media/calc-schengen.7be6db2b.png";